import { render, staticRenderFns } from "./feeHospital.vue?vue&type=template&id=7851beae&scoped=true"
import script from "./feeHospital.vue?vue&type=script&lang=js"
export * from "./feeHospital.vue?vue&type=script&lang=js"
import style0 from "./feeHospital.vue?vue&type=style&index=0&id=7851beae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7851beae",
  null
  
)

export default component.exports